import { render, staticRenderFns } from "./StormCauseTypeQuestion.vue?vue&type=template&id=0020aa21&scoped=true"
import script from "./StormCauseTypeQuestion.vue?vue&type=script&lang=ts"
export * from "./StormCauseTypeQuestion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0020aa21",
  null
  
)

export default component.exports